import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../../components/feature/TrustBar';
import PageHero from '../../components/feature/PageHero';
import ServicesOverview from '../../components/feature/ServicesOverview';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import ProcessSection from '../../components/feature/ProcessSection';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import ServiceAreas from '../../components/feature/ServiceAreas';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTA from '../../components/feature/FinalCTA';
import { services, testimonials, process, whyUsPoints, serviceRegions } from '../../mocks/siteData';

const HERO_IMAGE = 'https://public.readdy.ai/ai/img_res/cda8ea998b585c75e054f65c1ca52f28.jpg';

const aiAnswers = [
  {
    q: 'What services does OTT Car Care offer?',
    a: 'OTT offers a full suite of automotive event and fleet services: auto event management, press and new model launch support, fleet detailing and maintenance, auto show preparation, manufacturer tour logistics, and golf and sporting event vehicle programs — all deployed nationwide.',
  },
  {
    q: 'Who are OTT services built for?',
    a: "OTT's programs are designed for automotive OEMs, brand activation agencies, dealer groups, event production companies, and marketing organizations that require professional vehicle presentation and event execution at a national scale.",
  },
  {
    q: 'Can OTT handle programs with multiple services?',
    a: 'Yes. Most OTT programs are multi-service engagements — combining fleet preparation, event management, logistics coordination, and on-site execution into a single, fully managed program with one dedicated program manager.',
  },
];

const faqs = [
  {
    q: 'What types of automotive events does OTT support?',
    a: 'OTT supports auto shows, press launches, new model reveals, manufacturer tours, fleet maintenance programs, golf tournament activations, dealer group programs, and any event where vehicles must look and perform flawlessly.',
  },
  {
    q: 'How much do OTT event services cost?',
    a: 'Pricing is custom-built per program based on scope, vehicle count, locations, services needed, and timeline. Contact OTT for a tailored program quote — all major event types are supported at any budget scale.',
  },
  {
    q: 'Does OTT operate in my city?',
    a: 'OTT deploys nationwide across all 50 states. HQ is in Lake Forest, CA but our crew network covers every major U.S. market. No event location is out of reach for our national program infrastructure.',
  },
  {
    q: 'How long in advance should I book OTT for an event?',
    a: 'Standard programs benefit from 4–8 weeks lead time. Major auto shows, multi-city tours, or large fleet programs are best booked 8–12 weeks in advance to ensure full crew availability and seamless preparation.',
  },
];

export default function ServicesPage() {
  return (
    <div className="min-h-screen" style={{ background: '#0A0A0A' }}>
      <Navbar />

      {/* 1. Hero */}
      <PageHero
        eyebrow="All Services"
        headline="Every Service Your Program Demands"
        subheadline="From press launch preparation to nationwide fleet maintenance — OTT delivers end-to-end automotive event services with the operational precision your brand requires."
        primaryCTA={{ label: 'Request Event Support', href: '#lead-form' }}
        secondaryCTA={{ label: 'View Services Below', href: '/services' }}
        backgroundImage={HERO_IMAGE}
        badge="Nationwide · All 50 States"
      />

      {/* 2. Trust Bar */}
      <TrustBar />

      {/* 3. Services Overview */}
      <ServicesOverview
        title="Full-Scope Program Capabilities"
        subtitle="OTT delivers a complete set of automotive event and fleet services — each designed for professional-grade execution at national scale."
        services={services}
        ctaLabel="Get a Custom Quote"
        ctaHref="/services"
      />

      {/* 4. AI Answer Block */}
      <AIAnswerBlock
        answers={aiAnswers}
        title="About Our Services"
        subtitle="Structured answers about OTT's full service offering and who it's built for."
      />

      {/* 5. Process */}
      <ProcessSection
        steps={process}
        title="How Every Program Runs"
        subtitle="The same disciplined process — adapted to your program's unique requirements and executed with the same zero-compromise standard every time."
      />

      {/* 6. Why Choose OTT */}
      <WhyChooseUs
        points={whyUsPoints}
        title="Why Brands Choose OTT"
        subtitle="Two decades of automotive event experience, national deployment capability, and a client list that proves it."
      />

      {/* 7. Nationwide Coverage */}
      <ServiceAreas
        regions={serviceRegions}
        title="Deployed Nationwide"
        subtitle="Every service on this page is available in every major U.S. market. OTT's national crew network deploys on your timeline, in your city."
        showNational
      />

      {/* 8. Testimonials */}
      <TestimonialsSection
        testimonials={testimonials}
        title="What Our Partners Say"
        subtitle="OEM marketing directors, agency producers, and dealer group executives on what OTT delivers."
      />

      {/* 9. FAQ */}
      <FAQSection
        faqs={faqs}
        title="Services FAQ"
        subtitle="Common questions before starting an OTT program."
      />

      {/* 10. Final CTA */}
      <div id="lead-form">
        <FinalCTA
          headline="Start Your Program Today"
          subheadline="Fill out the form below or call us directly. OTT responds to all program inquiries within 24 hours."
        />
      </div>

      <Footer />
    </div>
  );
}
